import { enableMapSet } from "immer";
import type { EditorState, EditorOptions } from "./types";

enableMapSet();

export type Listener = () => void;

export interface Store {
  getState: () => EditorState;
  setState: (state: EditorState) => void;
  subscribe: (listener: Listener) => () => void;
}

export function createStore(options: EditorOptions): Store {
  let state: EditorState = {
    nodes: {},
    contentRevision: 0,
    events: {
      selected: new Set(),
      hovered: new Set(),
      dragged: new Set(),
    },
    options,
    indicator: null,
  };

  const listeners = new Set<Listener>();
  let notifyScheduled = false;

  function notifyListeners() {
    notifyScheduled = false;
    for (const listener of listeners) {
      listener();
    }
  }

  return {
    getState() {
      return state;
    },

    setState(nextState: EditorState) {
      if (nextState === state) return;
      state = nextState;
      // Batch notifications: coalesce multiple synchronous setState calls
      // into a single notification pass via microtask
      if (!notifyScheduled) {
        notifyScheduled = true;
        queueMicrotask(notifyListeners);
      }
    },

    subscribe(listener: Listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
